import { Controller } from "stimulus"
import $ from "jquery"
import "select2"

require("select2/dist/css/select2")
require("select2-bootstrap-theme/dist/select2-bootstrap")

export default class extends Controller {
  connect() {
    this.boundRefresh = this.refresh.bind(this)
    this.element.addEventListener("prescreen:refresh-selects", this.boundRefresh)
    this.initSelect2()
  }

  disconnect() {
    this.element.removeEventListener("prescreen:refresh-selects", this.boundRefresh)
    this.destroySelect2()
  }

  refresh() {
    this.destroySelect2()
    this.initSelect2()
  }

  selectableElements() {
    return $(this.element).find("select.select2-search-box, select.form-control").filter(function () {
      return !this.disabled && !this.closest("[data-no-prescreen-select2]")
    })
  }

  initSelect2() {
    this.selectableElements().each((_, select) => {
      const $select = $(select)
      if ($select.hasClass("select2-hidden-accessible")) {
        $select.select2("destroy")
      }

      // Keep tall form fields clipped inside their wrapper; attach filter
      // dropdowns to body so they don't force a horizontal scrollbar.
      const $formField = $select.closest(".prescreen-select-field")
      const $dropdownParent = $formField.length ? $formField : $(document.body)

      $select.select2({
        width: "100%",
        dropdownParent: $dropdownParent,
        placeholder: $select.data("placeholder") || undefined,
        dropdownAutoWidth: false,
        minimumResultsForSearch: 0
      })
    })

    this.selectableElements().off("select2:open.prescreen").on("select2:open.prescreen", (event) => {
      setTimeout(() => {
        const searchField = document.querySelector(".select2-container--open .select2-search__field")
        if (searchField) searchField.focus()
      }, 0)
    })
  }

  destroySelect2() {
    this.selectableElements().each((_, select) => {
      const $select = $(select)
      if ($select.hasClass("select2-hidden-accessible")) {
        $select.select2("destroy")
      }
    })
  }
}
